import { h, Component } from "preact";
import crLogo from "../images/cr_logo_up_navy.png";
import "./navbar_styles.css";
class NavBar extends Component {
  constructor() {
    super();
    this.state = {
      mobileMenuActive: false,
      buttonActive: false
    };
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
  }

  toggleMobileMenu() {
    this.setState({
      mobileMenuActive: !this.state.mobileMenuActive,
      buttonActive: !this.state.buttonActive
    });
  }

  render() {
    const mobileMenuClass = this.state.mobileMenuActive
      ? "nav-links active"
      : "nav-links";
    const buttonClass = this.state.buttonActive
      ? "toggle-button change"
      : "toggle-button";
    return (
      <div class="nav-container">
        <div class="logo-cont">
          <a href="/" class="logo">
            <img src={crLogo} alt="celina logo" />
          </a>
        </div>
        <div class="menu-container">
          <ul class={mobileMenuClass}>
            <li class="nav-item">
              <a href="/" onClick={this.toggleMobileMenu}>
                home
              </a>
            </li>
            <li class="nav-item">
              <a href="/resume" onClick={this.toggleMobileMenu}>
                resume
              </a>
            </li>
            <li class="nav-item">
              <a href="/projects" onClick={this.toggleMobileMenu}>
                projects
              </a>
            </li>
            <li class="nav-item">
              <a href="/writing" onClick={this.toggleMobileMenu}>
                writing
              </a>
            </li>
            <li class="nav-item">
              <a href="/me" onClick={this.toggleMobileMenu}>
                me
              </a>
            </li>
            <li class="nav-item">
              <a href="/contact" onClick={this.toggleMobileMenu}>
                contact
              </a>
            </li>
          </ul>
        </div>
        <div class={buttonClass} onClick={this.toggleMobileMenu}>
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>
      </div>
    );
  }
}

export default NavBar;
